import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

export const ME_GET_USER_INFO = gql(`
query MeGetUserInfo {
    meGetUserInfo {
        user {
            id
            firstName
            lastName
            phone
            email
            profilePictureId
            fieldworker {
                id
                userId
                isMyWheelsUser
                isPayable
                hasFinishedOnboarding
                address
                hasOwnTransport
                availability
                maxShiftsPerWeek
                coolOffBetweenShiftsInHours
                isActive
                hasConfirmedAvailability
                preferredTransportationMethod
            }
            tenantRole {
                id
                name
                permissions
            }
            profilePictureMedia {
                id
                name
                mimeType
                isUploaded
                url
            }
            userCourses {
                id
                name
                description
            }
        }
        tenant {
            id
            name
            userImportJobId
        }
    }
}
`);

export default function useMeGetUserInfoQuery() {
    const { data, loading, error } = useQuery(ME_GET_USER_INFO);

    return {
        data: data?.meGetUserInfo,
        loading,
        error,
    };
}
